// TABBED CONTENT
const tabbedContentSections = document.querySelectorAll('.o-sec.tabbed-content');
if(tabbedContentSections.length > 0) {
  tabbedContentSections.forEach(function(sliderSection) {
    const slider = sliderSection.querySelector('.c-slider.tab-content');
    const tabbedContentBtns = sliderSection.querySelectorAll('.c-slider.tab-nav .swiper-slide .c-btn');

    let sliderPagination = false;
    if(sliderSection.classList.contains('image_text')) {
      sliderPagination = true;
    }

    const tabbedContentSlider = new Swiper(slider, {
      loop: true,
      slidesPerView: 1,
      speed: 1200,
      draggable: false,
      simulateTouch: false,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: sliderSection.querySelector('.c-slider-arrows .c-slider-arrow.next'),
        prevEl: sliderSection.querySelector('.c-slider-arrows .c-slider-arrow.prev'),
      },
      on: {
        slideChange: function(slider) {
          tabbedContentBtns.forEach(function(btn) {
            btn.classList.remove('is-active');
          });

          tabbedContentBtns[slider.realIndex].classList.add('is-active');
        }
      }
    });

    if(sliderPagination) {
      tabbedContentSlider.on('slideChange', function(swiper) {
        const currentSlideIndex = swiper.realIndex;        
        const sliderBullets = sliderSection.querySelectorAll('.c-slider-bullet');
        sliderBullets.forEach(function(bullet, index) {
          if( index === currentSlideIndex ) {
            bullet.classList.add('active');
          } else {
            bullet.classList.remove('active');
          }
        });
      });
    }


    tabbedContentBtns.forEach(function(btn, index) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        tabbedContentSlider.slideTo(index);

        tabbedContentBtns.forEach(function(btn) {
          btn.classList.remove('is-active');
        });

        tabbedContentBtns[tabbedContentSlider.realIndex].classList.add('is-active');
      });
    });
  });
}